import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const SemaglutideCalculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.semaglutide} />;
};

export default SemaglutideCalculator;
